module.exports = __webpack_public_path__ + "static/media/eraser.802e2348.svg";